import { di } from '@dirootie-core/di';

const sanitizeField = di.str.startCase;

export const createRequiredMessage = (field: string) =>
  `Field '${sanitizeField(field)}' is required.`;

export const createMinMessage = (field: string, min: number) =>
  `Minimum number of characters are ${min}.`;

export const createMaxMessage = (field: string, max: number) =>
  `Maximum number of characters are ${max}.`;

export const createUrlMessage = (field: string, max: number) =>
  `Url is not valid.`;
export const errors = {
  required: createRequiredMessage,
  min: createMinMessage,
  max: createMaxMessage,
};
